<div class="applications-list-page">
  <progress-spinner *ngIf="isLoading"> </progress-spinner>
  <div class="app-content">
    <nrwl-apps-entity-widget [data]="dataSource"></nrwl-apps-entity-widget>
  </div>
</div>
